import React, {useState} from "react";
import CommonHeader from "../../components/Headers/CommonHeader";
import AddOrganization from "../../components/Modal/AddOrganization";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/ProtectedContent";
import PageURLContextProvider from "../../contexts/pageURLContext";
import OrgTable from "./organizationTable";
import "./organization.scss";

const OrganizationComponent = () => {
  const [modalStatus, setModalStatus] = useState(false);

  return (
    <SafeView>
      <ProtectedContent perms={["view_organization"]} showFallback>
        <>
          {modalStatus && (
            <AddOrganization
              open={modalStatus}
              onClose={() => setModalStatus(false)}
              onCancel={modalStatus}
            />
          )}
          <ProtectedContent perms={["add_organization"]}>
            <CommonHeader
              content={"Add Organization"}
              handleAddClick={() => setModalStatus(true)}
              testID={"add_organization"}
            />
          </ProtectedContent>
          <div className="table-container">
            <OrgTable />
          </div>
        </>
      </ProtectedContent>
    </SafeView>
  );
};

const Organization = () => {
  return (
    <PageURLContextProvider>
      <OrganizationComponent />
    </PageURLContextProvider>
  );
};

export default Organization;
